// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderConfirmationShippingInformationStyles } from "@steiner/Overrides/Widgets/OrderConfirmation/OrderConfirmationShippingInformation";
import { css } from "styled-components";

orderConfirmationShippingInformationStyles.shippingInformationGridContainer = {
    gap: 12,
};

orderConfirmationShippingInformationStyles.shippingInformationAddressGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};

orderConfirmationShippingInformationStyles.shippingInformationTitle = {
    variant: "h4",
    as: "h3",
    css: css`
        margin-bottom: 0;
    `,
};

orderConfirmationShippingInformationStyles.shippingAddressTitle = {
    variant: "h6",
    as: "h4",
};

orderConfirmationShippingInformationStyles.shippingInformationAddressGridItem = {
    width: [12, 4, 4, 4, 4],
    css: css`
        flex-direction: column;
    `,
};

orderConfirmationShippingInformationStyles.shippingInformationCarrierGridItem = {
    width: [12, 4, 4, 4, 4],
    css: css`
        flex-direction: column;
    `,
};

orderConfirmationShippingInformationStyles.shippingCarrierTitle = {
    variant: "h6",
    as: "h4",
};

orderConfirmationShippingInformationStyles.shippingInformationServiceGridItem = {
    width: [12, 4, 4, 4, 4],
    css: css`
        flex-direction: column;
    `,
};

orderConfirmationShippingInformationStyles.shippingServiceTitle = {
    variant: "h6",
    as: "h4",
};

orderConfirmationShippingInformationStyles.shippingCarrierDescription = orderConfirmationShippingInformationStyles.shippingServiceDescription = {
    css: css`
        line-height: 22px;
        font-size: 14px;
        font-weight: normal;
    `,
}